<template>
  <a-layout>
    <admin-sidebar v-if="!hideMenu"/>
    <!--内容-->
    <admin-page class="admin-page" :style="{paddingLeft:collapsed?collapsedWidth+'px':expandWidth+'px'}">
      <router-view/>
    </admin-page>
    <!--  公告  -->
    <v-board v-model:visible="show" v-if="$user().token"/>
  </a-layout>
</template>

<script setup>
import setting from "@/stores/setting";
import {storeToRefs} from "pinia";
import {useLocalStorage} from "@vueuse/core";

/*是否收缩*/
let {
  collapsed,
  collapsedWidth,
  expandWidth,
  hideMenu
} = storeToRefs(setting());

/* 展示公告 */
const show = useLocalStorage('show-board', true);

</script>

<style lang="scss">
.admin-page {
  transition: padding-left 0.2s ease;
}
</style>